import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTD = styled(View)(({
  theme
}) => ({
  borderTop: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`,
  borderRight: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
}));
const FeatureTableBodyNameCell = ({
  feature,
  isChildFeature,
  minBlockSize
}) => {
  const highestTierProduct = feature.productApiNames[0];
  return /*#__PURE__*/_jsx(StyledTD, {
    as: "td",
    children: /*#__PURE__*/_jsx(Flex, {
      paddingInlineStart: isChildFeature ? '800' : '400',
      paddingInlineEnd: "200",
      minBlockSize: minBlockSize,
      alignItems: "center",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: feature.descriptions[highestTierProduct]
        }),
        placement: "right",
        children: /*#__PURE__*/_jsx(Text, {
          typography: isChildFeature ? 'body-100' : 'body-125',
          paddingInlineEnd: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: feature.displayName
          })
        })
      })
    })
  });
};
export default FeatureTableBodyNameCell;